function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { children, optional, once } from '../Composite';
import Label from '../Label';
import Input from '../Input';
import RangeInputWithLabelComposite from '../Composite/RangeInputWithLabelComposite/RangeInputWithLabelComposite';

var Range = function Range(_ref) {
  var props = _objectWithoutProperties(_ref, []),
      children = _ref.children;

  return React.createElement(
    RangeInputWithLabelComposite,
    props,
    children
  );
};

Range.propTypes = {
  children: children(optional(Label), once(Input), once(Input))
};

Range.displayName = 'Range';

export default Range;
//# sourceMappingURL=Range.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Range/Range.js